export default __webpack_public_path__ + "static/media/logout.21c55458.svg";